import PlanSelector from "@/components/onboarding/plans/PlanSelector";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Pricing() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="w-full p-4">
        <Button onClick={() => navigate("/")} variant="ghost">
          <ArrowLeft className="group-hover:-translate-x-0.5 transition-all group-active:-translate-x-1" />
          Back
        </Button>
      </div>

      <PlanSelector />
    </div>
  );
}
